export default __webpack_public_path__ + "static/media/AIRFRANCE_3.2894e0dc.gif";